import * as React from 'react'
import { CircularProgress, Typography } from '@mui/material'
import { ISchool } from '../../../interfaces/school.interface'
import { ICourse } from '../../../interfaces/ICourse'
import { IUserDetails } from '../../../interfaces/user.interface'
import StudentUnregisteredActionComponent from '../../Classroom/ClassroomLearnersComponents/SchoolCourseDetails/StudentCourseDetailsActionComponents/StudentUnregisteredActionComponent'
import { IPaymentsPlan } from '../../../interfaces/IPaymentsPlan'
import {
  addNewCourseForStudent,
  checkIfStudentIsTakingCourse,
} from '../../../services/api-requests/api-request'
import { useEffect } from 'react'
import StudentRegisteredActionComponent from '../../Classroom/ClassroomLearnersComponents/SchoolCourseDetails/StudentCourseDetailsActionComponents/StudentRegisteredActionComponent'
import {
  getURLQueryParameter,
  removeURLQueryParameter,
} from '../../../services/config'
import { useRouter } from 'next/router'
import { useSnackbarComponent } from '../../SnackbarComponents/useSnackbarComponent'

interface IClassDetailsCardAction {
  course_details: ICourse
  user_details: IUserDetails
  schoolDetailsFromCourse: ISchool
  payment_plans: IPaymentsPlan[]
}

export default function StudentCourseDetailsCardActionButton(
  props: IClassDetailsCardAction,
) {
  const [studentCourseStatus, setStudentCourseStatus] = React.useState(
    'loading' as string,
  )
  const [openPaymentDetails, setOpenPaymentDetails] = React.useState(false)
  const router = useRouter()
  const class_url = `/courses/content/${props.course_details._id}`
  const snackbarHook = useSnackbarComponent()

  useEffect(() => {
    if (props.user_details) {
      checkIfStudentIsRegisteredToCourse()
    } else {
      setStudentCourseStatus('unregistered')
    }
  }, [props.user_details])

  React.useEffect(() => {
    const automaticallyOpenPayment =
      getURLQueryParameter('payButton') === 'true'
    if (automaticallyOpenPayment) {
      setOpenPaymentDetails(true)
      return undefined
    }
  }, [props.user_details])

  async function checkIfStudentIsRegisteredToCourse(goToClass?: boolean) {
    try {
      setStudentCourseStatus('loading')

      const automaticallyOpenClass =
        getURLQueryParameter('openClass') === 'true'
      if (automaticallyOpenClass) {
        removeURLQueryParameter('openClass')
      }

      const axiosRes = await checkIfStudentIsTakingCourse(
        props.course_details._id,
      )
      console.log('check if student is taking course', axiosRes)
      if (axiosRes && axiosRes.data && axiosRes.data.data) {
        const status = axiosRes.data.data.status
        if (status === 'unregistered' && automaticallyOpenClass) {
          await addNewCourseForStudent(
            props.course_details?._id,
            props.course_details?.course_code,
          )
          snackbarHook.open('Registration to course successful', 'success')
        }

        if (goToClass || automaticallyOpenClass) {
          router.push(class_url)
          // location.href = `${location.origin}/courses/content/${props.course_details._id}`;
        }
        setStudentCourseStatus(status)
      } else {
        setStudentCourseStatus('unregistered')
      }
    } catch (err) {
      console.log(err)
      setStudentCourseStatus('unregistered')
    }
  }

  return (
    <div style={{ width: '100%' }}>
      {studentCourseStatus === 'loading' && (
        <React.Fragment>
          <div style={{ width: '100%', textAlign: 'center' }}>
            <CircularProgress size={30} color="primary" />
            <Typography variant="body2" align="center" color="textSecondary">
              loading...
            </Typography>
            <div
              style={{
                position: 'fixed',
                width: '100%',
                height: '100%',
                top: '0px',
                left: '0px',
                background: 'black',
                opacity: 0.3,
                zIndex: 5,
              }}
            />
            <div
              style={{
                position: 'fixed',
                width: '100%',
                height: '100%',
                top: '0px',
                left: '0px',
                paddingTop: '50vh',
                textAlign: 'center',
                zIndex: 6,
              }}
            >
              <CircularProgress size={40} />
            </div>
          </div>
        </React.Fragment>
      )}

      {studentCourseStatus === 'unregistered' && (
        <StudentUnregisteredActionComponent
          course_details={props.course_details}
          schoolDetailsFromCourse={props.schoolDetailsFromCourse}
          user_details={props.user_details}
          reloadStudentCourseStatus={checkIfStudentIsRegisteredToCourse}
          payment_plans={props.payment_plans}
          openPaymentDetails={openPaymentDetails}
        />
      )}

      {/* {studentCourseStatus === "approved" && ( */}
      {/*    <StudentApprovedActionComponent */}
      {/*        school_details={props.school_details} */}
      {/*        course_details={props.course_details} */}
      {/*    /> */}
      {/* )} */}

      {/* {studentCourseStatus === "unapproved" && ( */}
      {/*  <StudentUnapprovedActionComponent */}
      {/*    course_details={props.course_details} */}
      {/*    school_details={props.school_details} */}
      {/*    user_details={props.user_details} */}
      {/*    reloadStudentCourseStatus={checkIfStudentIsRegisteredToCourse} */}
      {/*    payment_plans={props.payment_plans} */}
      {/*  /> */}
      {/* )} */}

      {['approved', 'unapproved'].includes(studentCourseStatus) && (
        <StudentRegisteredActionComponent
          schoolDetailsFromCourse={props.schoolDetailsFromCourse}
          course_details={props.course_details}
          courseStudentStatus={studentCourseStatus}
          user_details={props.user_details}
          reloadStudentCourseStatus={checkIfStudentIsRegisteredToCourse}
          openPaymentDetails={openPaymentDetails}
        />
      )}
    </div>
  )
}
